export default "__VITE_ASSET__C7nwdT96__"